export default "__VITE_ASSET__BxrjFrNT__"